<div class="repair-order">
  <div class="service-card" [ngClass]="{'repair-order-notes': !service.concernNumber}"
    *ngIf="service?.includeInInvoice || isDeferredServiceEnabled">
    <div class="s-card-header">
      <span class="flex-between-start flex-column">
        {{ helperService.getLocalizationValue(currentLang, service,'title') }}
      </span>

      <span class="flex-end-center flex-column" *ngIf="isDeferredServiceEnabled">
        {{ serviceAuthLabel[service?.serviceStatus] }}
      </span>
    </div>

    <div class="notes-section"
      *ngIf="appSettings?.isMultiLocationEnabled ? shopAppSettings?.displayExternalServiceNotes && service.notes : appSettings?.displayExternalServiceNotes && service.notes">
      <span class="assigned-techs pr-1">{{'service-notes'|translate}}:</span>
      <span class="technicians-list" style="white-space: pre-line" [innerHTML]="service.notes"> </span>
    </div>

    <div class="technicians-section"
      *ngIf="appSettings?.isMultiLocationEnabled ? shopAppSettings?.isShowTechnicianDetail : appSettings?.isShowTechnicianDetail">
      <span class="assigned-techs pr-1"> {{'assigned-techs'|translate}}:&nbsp; </span>
      <span class="technicians-list">
        {{ service.techDetails ? service.techDetails : 'no-tech-assigned'|translate }}
      </span>
    </div>

    <div class="s-card-body repair-order-service">
      <div *ngIf="!appSettings?.isShowLineItemDisInPdf" class="s-card-row flex-start-center">
        <p class="m-0 sno font-bold pr-2">{{'item'|translate}}</p>
        <p class="m-0 name font-bold pr-2">{{'name'|translate}}</p>
        <p class="m-0 description font-bold">{{'description'|translate}}</p>
        <p class="m-0 price font-bold">{{'price'|translate}}</p>
        <p class="m-0 quantity font-bold">{{'qty/hrs'|translate}}</p>
        <p class="m-0 total font-bold text-right">{{'amount'|translate}}</p>
      </div>

      <div *ngIf="appSettings?.isShowLineItemDisInPdf" class="s-card-row with-amount flex-start-center">
        <p class="m-0 sno font-bold">{{'item'|translate}}</p>
        <p class="m-0 name font-bold">{{'name'|translate}}</p>
        <p class="m-0 description font-bold" [ngClass]="isShowPriceQty ? 'inc-width' : ''">{{'description'|translate}}
        </p>
        <p *ngIf="!isShowPriceQty" class="m-0 price font-bold">{{'price-x-qty-/-hrs'|translate}}</p>
        <p *ngIf="!isShowPriceQty" class="m-0 amount font-bold">{{'amount'|translate}}</p>
        <p class="m-0 fees font-bold">{{'disc.-/-fees'|translate}}</p>
        <p class="m-0 total font-bold">{{'subtotal'|translate}}</p>
      </div>

      <div class="s-card-row with-amount" *ngFor="let item of service?.items; let itemIndex = index"
        [hidden]="!appSettings?.isShowLineItemDisInPdf && item.type === 'discount'">
        <div *ngIf="!appSettings?.isShowLineItemDisInPdf" class="flex-start-center">
          <p class="m-0 sno align-self-start">{{ itemIndex + 1 }}</p>

          <p class="m-0 name align-self-start pr-2">{{ item?.type === 'tireStorage' && item?.tireStorageStatus === 'return' ? 'Tires Out' : item?.type === 'tireStorage' && item?.tireStorageStatus !== 'return' ? 'Tires In - ' + helperService.getLocalizationValue(currentLang, item,'title') : helperService.getLocalizationValue(currentLang, item,'title') }}
            <span *ngIf="item.type === 'tire' && item.dotNumbers?.length > 0">
              <br>
              <ng-container *ngFor="let dot of item.dotNumbers; let i=index">
                <span class="font-10" *ngIf="dot.dotNumber">{{'tire'|translate}} {{i+1}} ({{dot.tirePosition}}):
                  {{dot.dotNumber}}</span><br>
              </ng-container>
            </span>
            <!-- warranty number -->
            <span
              *ngIf="['tire','part'].includes(item.type) && isPartWarrantiesEnabled && isWarrantyNumberAddonEnabled && item?.warranty?.warrantyNumber">
              <br>
              ({{item?.warranty?.warrantyNumber}})
            </span>
          </p>

          <p class="m-0 description align-self-start">
            <span [innerHTML]="helperService.getLocalizationValue(currentLang, item,'description',true)"
              [ngClass]="{ 'd-none': item.type !== 'other' && item.type !== 'sublet' && !item.displayDescOnOrder }">
            </span>
          </p>

          <p class="m-0 price align-self-start">
            <span
              [ngClass]="{ invisible: item.type !== 'other' && item.type !== 'sublet' && !item.displayHoursOnOrder }">
              {{ item.pricingType === 'flatFee' && item.tireStorageStatus !== 'return' && item.type === 'tireStorage' && isTireStorage2Enabled ? (item?.subTotal || 0 | currency : usd) : (item?.price || 0 | currency : usd) }}
            </span>
          </p>

          <p class="m-0 quantity align-self-start pr-3">
            <span
              [ngClass]="{ invisible: item.type !== 'other' && item.type !== 'sublet' && !item.displayHoursOnOrder }">
              {{ item.pricingType === 'flatFee' && item.tireStorageStatus !== 'return' && item.type === 'tireStorage' && isTireStorage2Enabled ? 1 : item?.count }}
            </span>
          </p>
          <p class="m-0 total text-right align-self-start">{{ item?.subTotal || 0 | currency : usd }}</p>
        </div>

        <div *ngIf="appSettings?.isShowLineItemDisInPdf" class="flex-start-center">
          <p class="m-0 sno align-self-start">{{ itemIndex + 1 }}</p>

          <p class="m-0 name align-self-start pr-2">{{ item?.type === 'tireStorage' && item?.tireStorageStatus === 'return' ? 'Tires Out' : item?.type === 'tireStorage' && item?.tireStorageStatus !== 'return' ? 'Tires In - ' + helperService.getLocalizationValue(currentLang, item,'title') : helperService.getLocalizationValue(currentLang, item,'title') }}
            <span *ngIf="item.type === 'tire' && item.dotNumbers?.length > 0">
              <br>
              <ng-container *ngFor="let dot of item.dotNumbers; let i=index">
                <span class="font-10" *ngIf="dot.dotNumber">Tire {{i+1}} ({{dot.tirePosition}}):
                  {{dot.dotNumber}}</span><br>
              </ng-container>
            </span>
            <!-- warranty number -->
            <span
              *ngIf="['tire','part'].includes(item.type) && isPartWarrantiesEnabled && isWarrantyNumberAddonEnabled && item?.warranty?.warrantyNumber">
              <br>
              ({{item?.warranty?.warrantyNumber}})
            </span>
          </p>

          <p class="m-0 description align-self-start" [ngClass]="isShowPriceQty ? 'inc-width' : ''">
            <span [innerHTML]="helperService.getLocalizationValue(currentLang, item,'description',true)"
              [ngClass]="{ 'd-none': item.type !== 'other' && item.type !== 'sublet' && !item.displayDescOnOrder }">
            </span>
          </p>

          <p *ngIf="!isShowPriceQty && item?.type !== 'bundle'" class="m-0 price align-self-start"
            [ngClass]="{ invisible: item.type !== 'bundle' && item.type !== 'other' && item.type !== 'sublet' && !item.displayHoursOnOrder }">
            <span [hidden]="
                (item?.type == 'bundle' || item?.type == 'part' || item?.type == 'labor' || item?.type == 'tire' || item?.type == 'hazmatFee' || item?.type == 'discount') && !item?.displayHoursOnOrder
              ">
              <span *ngIf="item.pricingType === 'flatFee' && item.tireStorageStatus !== 'return' && item.type === 'tireStorage' && isTireStorage2Enabled; else templateWithNoFlatfee" >{{ item?.subTotal || 0 | currency : usd }} x 1</span>
              <ng-template #templateWithNoFlatfee>
                <span>{{ item?.price || 0 | currency : usd }} x {{ item?.count }}</span>
              </ng-template>
            </span>
          </p>

          <p *ngIf="!isShowPriceQty && item?.type == 'bundle'" class="m-0 price align-self-start"
            [ngClass]="{ invisible: item.type !== 'bundle' && item.type !== 'other' && item.type !== 'sublet' && !item.displayHoursOnOrder }">
            <span [hidden]="
                (item?.type == 'bundle' || item?.type == 'part' || item?.type == 'labor' || item?.type == 'tire' || item?.type == 'hazmatFee' || item?.type == 'discount') && !item?.displayHoursOnOrder
              ">
              {{ getBundleSumWithoutHazmatFee(item) || 0 | currency : usd }} x {{ item?.count }}
            </span>
          </p>

          <p class="m-0 amount text-right align-self-start" *ngIf="!isShowPriceQty">
            <span *ngIf="item.type !== 'discount' && item.type !== 'hazmatFee' && item?.type !== 'bundle'">
              {{ item?.subTotal || 0 | currency : 'USD' }}
            </span>
            <span *ngIf="item?.type == 'bundle'">
              <ng-container>
                <ng-container>
                  {{ getBundleSumWithoutHazmatFee(item) | currency : 'USD' }}
                </ng-container>
              </ng-container>
            </span>
          </p>

          <p class="m-0 fees text-right align-self-start">
            <span *ngIf="item.type == 'discount'">
              {{ item?.subTotal * -1 || 0 | currency : 'USD' }}
            </span>
            <span *ngIf="item.type == 'hazmatFee'">
              {{ item?.subTotal || 0 | currency : 'USD' }}
            </span>
            <span
              *ngIf="item.type !== 'discount' && item.type !== 'hazmatFee' && item.type !== 'bundle' && item?.discountAmt !== 0">
              {{ item?.discountAmt * -1 | currency : 'USD' }}
            </span>
            <span *ngIf="item?.type == 'bundle'">
              <ng-container>
                <ng-container>
                  {{ getBundleSumWithHazmatFee(item) | currency : 'USD' }}
                </ng-container>
              </ng-container>
            </span>
          </p>

          <p class="m-0 total text-right align-self-start">{{ (item.type === 'discount' ? item?.netSubTotal * -1 :
            item?.netSubTotal || 0) | currency : 'USD' }}</p>
        </div>

        <!-- tire storage enhancement section -->
        <div class="flex-row tire-specs"
          *ngIf="isEnhancedTSEnabled && isTreadDepthVisibleOnInvoice && item?.tiresInfo?.length && item?.type === 'tireStorage'">
          <div class="flex-center flex-row tire-specs-detail pr-2 border-right-light">
            <div class="font-700 font-10 font-gray-500">{{'front'|translate}}</div>
            <div class="flex-between flex-column tire-spec-group">
              <div class="flex-between-end flex-row">
                <div class="tire-spec font-700 font-12" [ngClass]="{
                    'tire-threshold': item.fr?.isReplacementRecommended,
                    'tire-not-added': !item.fr?.isExist
                  }">
                  {{ item.fr?.label }}{{ item.fr?.isExist ? item.fr?.treadDepth : 'N/A' }}
                </div>
                <div class="tire-spec font-700 font-12" [ngClass]="{
                    'tire-threshold': item.rr?.isReplacementRecommended,
                    'tire-not-added': !item.rr?.isExist
                  }">
                  {{ item.rr?.label }}{{ item.rr?.isExist ? item.rr?.treadDepth : 'N/A' }}
                </div>
              </div>
              <div class="flex-center-center">
                <img src="assets/img/tire-enhacement.svg" />
              </div>
              <div class="flex-between-start flex-row">
                <div class="tire-spec font-700 font-12" [ngClass]="{
                    'tire-threshold': item.fl?.isReplacementRecommended,
                    'tire-not-added': !item.fl?.isExist
                  }">
                  {{ item.fl?.label }}{{ item.fl?.isExist ? item.fl?.treadDepth : 'N/A' }}
                </div>
                <div class="tire-spec font-700 font-12" [ngClass]="{
                    'tire-threshold': item.rl?.isReplacementRecommended,
                    'tire-not-added': !item.rl?.isExist
                  }">
                  {{ item.rl?.label }}{{ item.rl?.isExist ? item.rl?.treadDepth : 'N/A' }}
                </div>
              </div>
            </div>
            <div class="font-700 font-10 font-gray-500">{{'rear'|translate}}</div>
          </div>
          <div class="flex-row flex-center tire-specs-detail pl-2">
            <div class="font-700 font-10 font-gray-500">{{'spares'|translate}}</div>
            <div class="flex-between flex-column tire-spec-group">
              <div class="flex-between-center">
                <span class="tire-spec font-700 font-12" [ngClass]="{
                    'tire-threshold': item.s1?.isReplacementRecommended,
                    'tire-not-added': !item.s1?.isExist
                  }">
                  {{ item.s1?.label }}{{ item.s1?.isExist ? item.s1?.treadDepth : 'N/A' }}
                </span>
              </div>

              <div class="flex-between-center">
                <span class="tire-spec font-700 font-12" [ngClass]="{
                    'tire-threshold': item.s2?.isReplacementRecommended,
                    'tire-not-added': !item.s2?.isExist
                  }">
                  {{ item.s2?.label }}{{ item.s2?.isExist ? item.s2?.treadDepth : 'N/A' }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div *ngFor="let subItem of item?.subItems; let itemIndex = index" [hidden]="!isFlatRateSubItemVisibleToCust"
          class="sub-item flex-start-center">
          <p class="m-0 sno align-self-start"></p>

          <p class="m-0 name align-self-start pr-2">
            <i class="far fa-level-up-alt transform-90deg"></i>
            <span class="pl-2">{{ helperService.getLocalizationValue(currentLang, subItem,'title') }}</span>
            <!-- warranty number -->
            <span
              *ngIf="['tire','part'].includes(subItem.type) && isPartWarrantiesEnabled && isWarrantyNumberAddonEnabled && subItem?.warranty?.warrantyNumber">
              <br>
              ({{subItem?.warranty?.warrantyNumber}})
            </span>
          </p>

          <p class="m-0 description align-self-start">
            <ng-container *ngIf="isFlatRateSubItemDescVisibleToCust">
              <span [innerHTML]="helperService.getLocalizationValue(currentLang, subItem,'description',true)"
                [ngClass]="{ 'd-none': !subItem?.displayDescOnOrder }"> </span>
            </ng-container>
          </p>

          <ng-container *ngIf="appSettings?.isShowLineItemDisInPdf">
            <p class="m-0 price align-self-start">
              <ng-container *ngIf="!isShowPriceQty">
                <span [hidden]="!subItem?.displayHoursOnOrder || !appSettings?.isFlatRateSubItemQtyVisibleToCust"> {{
                  subItem?.price || 0 | currency : usd }} x {{ subItem?.count }} </span>
              </ng-container>
            </p>

            <p class="m-0 amount text-right align-self-start" *ngIf="!isShowPriceQty">
              <ng-container *ngIf="subItem.type !== 'hazmatFee'">
                <span [hidden]="!appSettings?.isFlatRateSubItemQtyVisibleToCust">
                  {{ subItem?.flatRateAmount || 0 | currency : 'USD' }}
                </span>
              </ng-container>
            </p>

            <p class="m-0 fees text-right align-self-start">
              <ng-container *ngIf="subItem.type === 'hazmatFee'">
                <span [hidden]="!appSettings?.isFlatRateSubItemQtyVisibleToCust">
                  {{ subItem?.subTotal || 0 | currency : 'USD' }}
                </span>
              </ng-container>
            </p>

            <p class="m-0 total text-right align-self-start">
              <span [hidden]="!appSettings?.isFlatRateSubItemQtyVisibleToCust">
                {{ subItem?.netSubTotal || 0 | currency : 'USD' }}
              </span>
            </p>
          </ng-container>

          <ng-container *ngIf="!appSettings?.isShowLineItemDisInPdf">
            <p class="m-0 price align-self-start">
              <span [hidden]="!subItem?.displayHoursOnOrder || !appSettings?.isFlatRateSubItemQtyVisibleToCust">
                {{ subItem?.price || 0 | currency : usd }}
              </span>
            </p>

            <p class="m-0 quantity align-self-start pr-3">
              <span [hidden]="!subItem?.displayHoursOnOrder || !appSettings?.isFlatRateSubItemQtyVisibleToCust">
                {{ subItem?.count }}
              </span>
            </p>

            <p class="m-0 total text-right align-self-start">
              <span [hidden]="!appSettings?.isFlatRateSubItemQtyVisibleToCust">
                {{ subItem?.subTotal || 0 | currency : usd }}
              </span>
            </p>
          </ng-container>
        </div>
      </div>
    </div>

    <div class="s-card-footer" [ngClass]="checkApprovalStatus() ? 'flex-between-center' : 'flex-end-center'">
      <div class="width-60p text-truncate" *ngIf="checkApprovalStatus()">
        <span class="secondary-700 font-10-5">
          <span class="capitalize">
            <ng-container *ngIf="service?.approveConfirmation?.status === 'deferred'">
              {{ 'estimate.deferred' | translate }}
            </ng-container>
            <ng-container *ngIf="service?.approveConfirmation?.status === 'approved'">
              {{ 'approved' | translate }}
            </ng-container>
            <ng-container *ngIf="service?.approveConfirmation?.status === 'declined'">
              {{ 'estimate.deferred' | translate }}
            </ng-container>
            <ng-container
              *ngIf="service?.approveConfirmation?.status !== 'deferred' && service?.approveConfirmation?.status !== 'approved' && service?.approveConfirmation?.status !== 'declined'">
              {{ service?.approveConfirmation?.status }}
            </ng-container>
            &nbsp;<span class="text-lowercase">by</span>&nbsp;{{ service?.approveConfirmation?.fullName }}&nbsp;{{
            service?.approveConfirmation?.method }}
          </span>
          on {{ service?.approveConfirmation?.createdAt }}
        </span>
      </div>

      <div class="width-40p with-amount-footer">
        <span class="font-500 dynamicFont font14 amount">
          <!-- fixed for ALP-18302 -->
          {{'amount'|translate}}: <br />
          <!-- {{ service?.serviceTotal?.total - service?.serviceTotal?.hazmatFee | currency : usd }} -->
          {{ service?.serviceTotal?.total - (service?.serviceTotal?.hazmatFee || 0) | currency : usd }}
        </span>
        <span class="font-500 dynamicFont font14 fees">
          <!-- fixed for ALP-18302 -->
          {{'disc'|translate}}: {{ (service?.serviceTotal?.serviceLevelDiscount +
          (service?.serviceTotal?.itemLevelDiscount || 0))
          * (appSettings?.isShowLineItemDisInPdf? -1 : 1) | currency: usd }}
          <br />
          <span *ngIf="service?.serviceTotal?.hazmatFee">
            {{'fees'|translate}}: {{ service?.serviceTotal?.hazmatFee | currency : usd }}
          </span>
        </span>
        <span class="font-500 dynamicFont font14 total">
          <!-- fixed for ALP-18302 -->
          {{'subtotal'|translate}}: <br />
          {{ service?.serviceTotal?.total - (service?.serviceTotal?.serviceLevelDiscount +
          service?.serviceTotal?.itemLevelDiscount || 0) | currency : usd }}
        </span>
      </div>
    </div>
  </div>
</div>